import { useCssTokens } from '../../hooks/useCssTokens';

const radiusTokens = [
  { token: 'radius-xs', label: 'xs' },
  { token: 'radius-sm', label: 'sm' },
  { token: 'radius-md', label: 'md' },
  { token: 'radius-lg', label: 'lg' },
  { token: 'radius-xl', label: 'xl' },
  { token: 'radius-2xl', label: '2xl' },
  { token: 'radius-pill', label: 'pill' },
];

export function RadiusShowcase() {
  const values = useCssTokens(radiusTokens.map((item) => item.token));

  return (
    <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
      {radiusTokens.map((item) => (
        <div key={item.token} className="flex flex-col items-center rounded-2xl border border-border/40 p-4">
          <div
            className="h-14 w-14 border-2 border-primary/40 bg-muted/60"
            style={{ borderRadius: `var(--${item.token})` }}
          />
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.15em] text-foreground">{item.label}</p>
          <p className="text-xs text-muted-foreground">{values[item.token]}</p>
        </div>
      ))}
    </div>
  );
}
